import React from 'react'
import './scoreBar.scss'
import tooltip from '../../../../assets/tool-tip.svg';

interface ScoreBarProps {
    score: number
    color: string
    title: string;
    toolTipHelp?: string;
}

const ScoreBar = (props: ScoreBarProps) => {

    return (
        <div className='score-bar'>
            <h3 className="score-bar__title">{props.title}</h3>
            <p className="score-bar__tooltip-info__description">{props.toolTipHelp}</p>
            <img
                src={tooltip}
                alt="Información"
                className="score-bar__tooltip"
            />
            <div className="score-bar__tooltip-info">
                <h3 className="score-bar__tooltip-info__title">{props.title}</h3>
                <p className="score-bar__tooltip-info__description">{props.toolTipHelp}</p>
            </div>
            <div className="score-bar__container">
                <div
                    className="score-bar__container__fill"
                    style={{ backgroundColor: props.color, width: props.score + '%' }}
                >
                    <div
                        className="score-bar__container__fill__indicator"
                        style={{ color: props.color }}
                    >
                        <h3 className="score-bar__container__fill__indicator__text">
                            {props.score}
                        </h3>
                        <div className="score-bar__container__fill__indicator__arrow" />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ScoreBar;